export default "__VITE_ASSET__PY6ryL6b__"